import { inject, Injectable } from "@angular/core";
import { map, Observable, of } from "rxjs";
import { ApiDataService } from "src/app/api/services/api-data.service";
import { ResultsService } from "src/app/controls/base/results.service";
import { ColumnDefinition } from "src/app/controls/grid/models/column-definition.interface";
import { GridDataProvider } from "src/app/controls/grid/services/grid-data-provider.interface";
import { CompetitionResult } from "../models/competition-result.interface";
import { CompetitionCardService } from "../../competition-management/edit-competition-card/service/competition-card.service";

@Injectable()
export class CompetitionResultsTableService implements GridDataProvider, ResultsService {

    /** Api data service reference */
    private service = inject(ApiDataService);

    /** Competition service reference */
  private competitionService = inject(CompetitionCardService);
    
    /** @inheritdoc */
    public getTableName(competitionId: number): Observable<string> {
        return this.service.get<string>('competitions/get-name/' + competitionId);
    }

    /** @inheritdoc */
    public getGridData(competitionId: unknown): Observable<CompetitionResult[]> {
        return this.service.getAll<CompetitionResult>('competition-results/competition/' + competitionId).pipe(
            map((results => {
              results.map((result) => ({
                ...result,
                stages: this.mapRounds(result),
              }));
              return results;
          })));
    }

    /**
     * Maps the dynamic round columns
     * @param result the obtained competition result to map
     */
    private mapRounds(result: CompetitionResult): void {
        for (const round of result?.rounds) {
        result[round.columnId] = round.value;
        }
    }

    /** @inheritdoc */
    public getColumnDefinition(competitionId: number): Observable<ColumnDefinition[]> {
        return this.service.getAll<ColumnDefinition>('competition-results/column-definition/' + competitionId);
    }

    /** @inheritdoc */
    public recalculateResults(id: number): Observable<void> {
        return this.service.patchEmpty<void>('competition-results/recalculate/' + id);
    }
    
    /** @inheritdoc */
    public getDisplayResultsStatus(id: number): Observable<boolean> {
        return this.competitionService.getDisplayResultsStatus(id);
    }

    /** @inheritdoc */
    public updateResultsStatus(id: number): Observable<void> {
        return this.competitionService.updateResultsStatus(id);
    }
}